var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-md-12" }, [
      _c("div", { staticClass: "row" }, [
        _vm.disableSaveButtons
          ? _c("div", { staticClass: "col-md-8" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-success button-save",
                  attrs: { type: "button" },
                  on: { click: _vm.sendToProduction }
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.trans("overproduction.save")) +
                      "\n        "
                  )
                ]
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.disableSaveButtons
          ? _c(
              "div",
              { staticClass: "col-md-4 text-right" },
              [
                _c("history", {
                  attrs: {
                    "route-name": "api_get_entity_logger_show_overproduction",
                    date: this.formDate
                  }
                })
              ],
              1
            )
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-25a72f36", { render: render, staticRenderFns: staticRenderFns })
  }
}